import React, { useState,useEffect,useCallback } from "react";
import api from "views/auth/Api";
import { Link } from "react-router-dom";
import "./training.css"
import "../library/library.css"
import { API_BASE_URL } from '../../../configs/AppConfig';
import { FILES_URL } from '../../../configs/AppConfig';
import { jwtDecode } from "jwt-decode";
import { FiFilePlus } from "react-icons/fi";


const AllTraining = () => {
  const [data , setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

    const limit = 20; 

    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role

  const getData = useCallback(async()=>{
    await api.get(`${API_BASE_URL}training`,{
      params: { page, limit},
  })
  .then(function (response) {
            console.log("handlesubmit  ", response.data)
        setData(response.data?.items)
        setTotalPages(response.data.totalPages);
  }).catch(error => {
    console.log("handlesubmit error for blog get ", error)
  });
  }, [page, limit]);

  useEffect(()=>{ 
    getData();
  },[getData]);
  
  return (
    <div className="">
      <div className="train-header">
          <div className="train-h"> Enhance your Teaching Skills With Our Training Programs
          </div>
            {/* <div className="btnDev">
            <span>All Categories</span>
            <div className="dropdownImg"></div>
        </div> */}
      </div>
        {/* Projects cards */}
      {role === "Admin" ? <Link to={"/admin/training/add"}>  <div className="newChallenge ml-auto mb-[30px]">
                  <FiFilePlus className="addImg"/>
                  <span>Add Training</span>
                </div> </Link> : null}

        <div className="trainingLayout">
              {data.map(training =>
            <div className="training-Cards">
            <div className="cardImg-tr" style={{backgroundImage:`url(${FILES_URL}${training.img?.url})`}}></div>
            <div className="cardInfo-tr">
              <div className="cardInfo-tr-head"> 
                <h4>{training.name} </h4>
                </div>
                {/* <p>reproduced in their exact original form, accompanied by English versions from the 1914 </p> */}
                {/* <span>progress</span>
              <div class="progress-training">
                <div class="training-bar" ></div>
                 </div> */}
             {role === "Teacher" ? <Link to={`/admin/training/field/${training.id}`} className="LinkFild" >
                 <button className="enroll">Enroll</button> </Link> :
                  role === "Admin" ? <Link to={`/admin/training/voxel/${training.id}`} className="LinkFild" >
                 <button className="enroll">View</button> </Link> : null }
              </div>
          </div>
          )}
        </div>
        {!data[0] ?  null :
       <div className="flex items-center justify-center mt-6 mb-8 gap-3 bottom-0 ">
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`min-w-[40px] px-3 py-2 rounded-lg ${
              page === i + 1
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>}
    </div>
  );
};

export default AllTraining;
